// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"bc6447e3f75a86b27944","293":"e148f5ac4616493b28c3","518":"9ea7b4160460ed21b04d","779":"fcd7f5d33416fe6672e5"}[chunkId] + ".js";
};